import React, { useState, useEffect } from "react";
import { getAxiosResponse, postAxiosResponse } from "../../../services/authApiRoutes/APImethods";
import APIUrls from "../../../services/APIUrls";
import Constants from "../../../Constants";
import { transformBlankToNull } from "../../../services/Util";
import Select from "react-select";
import { getLoggedInUserRole } from "../../../services/Util";
import $ from 'jquery';
export default function Preferences(prop) {
  const user = prop.user;
  const roleArray = getLoggedInUserRole();
  const userDisplay = user?.displayName[0]
  const [preferencesEnable, setpreferencesEnable] = useState(false);
  const [timeZones, setTimeZones] = useState([]);
  const [selectedTimeZone, setSelectedTimeZone] = useState(userDisplay.timeZone);
  const [locales, setLocales] = useState([]);
  const [selectedLocale, setSelectedLocale] = useState(userDisplay.locale);
  const [displayLanguages, setDisplayLanguages] = useState([]);
  const [selectedDisplayLanguage, setSelectedDisplayLanguage] = useState(userDisplay.language[0]);

  const preferencesEdit = (state) => {
    setpreferencesEnable(state);
    if (state) {
        setTimeout(() => {
          $("label ~ .global-dropdown-select input[id^='react-select-']:first").trigger('focus');
        }, 300);
    }
    else {
      setTimeout(() => {
        $('#edit-btn').trigger('focus');
      }, 300);
    }
  };
  useEffect(()=>{
    prop.editMode ? preferencesEdit(true) : preferencesEdit(false)
  },[prop])
  const handleTimeZoneSelect = (event) => {
    var selectedZone = event.value;
    setSelectedTimeZone(selectedZone);
  };
  const handleLocaleSelect = (event) => {
    var selectedLocale = event.value;
    
    setSelectedLocale(selectedLocale);
  };
  const handleDisplayLanguageSelect = (event) => {
    var selectedLanguageDisplay = event.value;
   setSelectedDisplayLanguage(selectedLanguageDisplay);
  };
  const savePeference = () => {
    var userOrignal = user.resource
    var updatedTimeZone = {id:selectedTimeZone.id,displayName:selectedTimeZone.localizedName}
    userOrignal.language = selectedDisplayLanguage.name
    userOrignal.timeZone = updatedTimeZone.id
    userOrignal.locale =  selectedLocale.value 
    var payload = transformBlankToNull(userOrignal)
    if(!roleArray.includes('ROLE_VENDOR')){
    postAxiosResponse(APIUrls.GET_FULL_USER_BY_ID(user.resource.userId),payload)
    .then((res)=>{
      prop.funct()
      setpreferencesEnable(false)
    })
    $('button.active').trigger('focus');
  }
  else{
    postAxiosResponse(APIUrls.GET_FULL_USER_BY_ID_VENDOR(user.resource.userId),payload)
    .then((res)=>{
      prop.funct()
      setpreferencesEnable(false)
    })
  }
  };
  useEffect(() => {
    getAxiosResponse(APIUrls.GET_TIMEZONE_LIST).then((res) => {
      var options = [];
      res.data.data.map((zone) =>
        options.push({
          label: zone.localizedName,
          value: zone,
        })
      );
      setTimeZones(options);
    });
    getAxiosResponse(APIUrls.GET_LOCALES_LIST).then((res) => {
      var options = [];
      res.data.data.map((lang) =>
        options.push({
          label: lang.display,
          value: lang,
        })
      );
      setLocales(options);
    });
    getAxiosResponse(APIUrls.GET_DISPLAY_LANGUAGE_LIST).then((res) => {
      var options = [];
      res.data.data.map((lang) =>
        options.push({
          label: lang.display,
          value: lang,
        })
      );
      setDisplayLanguages(options);
    });
    $('.calendarNumberFormat input').attr('aria-required', 'true');
    $('.uiDisplayLanguage input').attr('aria-required', 'true');
  }, []);
  return (
    <>
      <div className="inner-heading permissions-tab-content flex">
        <div className="left">
          <h4>Timezone, Calendar & Number Format</h4>
        </div>
        <div className="flex two-col flex-center">
          {!preferencesEnable ? (
            <button
            id="edit-btn"
              className="dashboard-btn"
              onClick={() => preferencesEdit(true)}
            >
              Edit
            </button>
          ) : null}
        </div>
      </div>
      <div className="permission-list">
        <div
          className={
            !preferencesEnable ? "after-show-data show" : "after-show-data hide"
          }
        >
          <h5>Time Zone</h5>
          <div className="read-data">
            <span>{user.displayName[0].timeZone.displayName}</span>
          </div>
        </div>
        <div
          className={
            !preferencesEnable
              ? "flex wrap-dropdown hide"
              : "flex wrap-dropdown show"
          }
        >
          <div className="global-dropdown-block flex-center">
            <label>Time Zone</label>
            <Select
              className="global-dropdown-select"
              menuShouldScrollIntoView={false}
              closeMenuOnSelect={true}
              classNamePrefix='cw'
              value={timeZones.filter(function (option) {
                return option.value.id === selectedTimeZone.id;
              })}
              placeholder="Select Timezone"
              aria-label="Timezone"
              options={timeZones}
              onChange={(e) => handleTimeZoneSelect(e)}
            />
          </div>
        </div>
      </div>
      <div className="permission-list">
        <div
          className={
            !preferencesEnable ? "after-show-data show" : "after-show-data hide"
          }
        >
          <h5>Calendar and Number Format</h5>
          <div className="read-data">
            <span>{user.displayName[0].locale.display}</span>
          </div>
        </div>
        <div
          className={
            !preferencesEnable
              ? "flex wrap-dropdown hide"
              : "flex wrap-dropdown show"
          }
        >
          <div className="global-dropdown-block flex-center">
            <label>Calendar and Number Format*</label>
            <Select
              className="global-dropdown-select calendarNumberFormat"
              menuShouldScrollIntoView={false}
              closeMenuOnSelect={true}
              classNamePrefix='cw'
              placeholder="Select Locale"
              value={locales.filter(function (option) {
                return option.value.value === selectedLocale.value;
              })}
              aria-label="Calendar and Number Format"
              options={locales}
              onChange={(e) => handleLocaleSelect(e)}
            />
          </div>
        </div>
      </div>
      <div className="permission-list">
        <div
          className={
            !preferencesEnable ? "after-show-data show" : "after-show-data hide"
          }
        >
          <h5>OPAL-Marketing UI Display Language</h5>
          <div className="read-data">
            <span>{user.displayName[0].language[0].display}</span>
          </div>
        </div>
        <div
          className={
            !preferencesEnable
              ? "flex wrap-dropdown hide"
              : "flex wrap-dropdown show"
          }
        >
          <div className="global-dropdown-block flex-center">
            <label>OPAL-Marketing UI Display Language*</label>
            <Select
              className="global-dropdown-select uiDisplayLanguage"
              menuShouldScrollIntoView={false}
              closeMenuOnSelect={true}
              classNamePrefix='cw'
              value={displayLanguages.filter(function (option) {
                return option.value.code === selectedDisplayLanguage.code;
              })}
              placeholder="Select display language"
              aria-label="OPAL-Marketing UI Display Language"
              options={displayLanguages}
              onChange={(e) => handleDisplayLanguageSelect(e)}
            />
          </div>
        </div>
      </div>
      {preferencesEnable ?  <div className="stricy-btn flex flex-center no-rightlist justify-end">
        <div className="left flex">
          <div>
            <button
              className="btn-default"
              onClick={() => preferencesEdit(false)}
            >
              Cancel
            </button>
          </div>
          <div>
            <button
              className={
                selectedTimeZone.id === undefined ||
                selectedLocale.value === undefined ||
                selectedDisplayLanguage.code === undefined
                  ? "btn disabled"
                  : "btn-default"
              }
              onClick={() => savePeference()}
              disabled={
                selectedTimeZone.id === undefined ||
                selectedLocale.value === undefined ||
                selectedDisplayLanguage.code === undefined
              }
            >
              Save Changes
            </button>
          </div>
        </div>
      </div> : null}
     
    </>
  );
}
